import { useLanguage } from "@/context/LanguageContext";

const SkipLink = () => {
  const { t } = useLanguage();

  return (
    <a
      href="#main-content"
      className="fixed top-4 left-4 z-[100] -translate-y-[200%] focus:translate-y-0 transition-transform duration-300 px-6 py-3 bg-background border border-primary text-primary font-bold rounded-lg shadow-xl ring-2 ring-primary focus:outline-none"
    >
      {t("common.skipToContent")}
    </a>
  );
};

export default SkipLink;
